import React from "react";
import "../../styles/Modals.css";

const DeleteConfirmModal = ({ itemTitle, onClose, onConfirm }) => {
    return (
        <div
          className="modal-backdrop"
          onClick={(e) => {
            if (e.target.classList.contains("modal-backdrop")) {
              onClose();
            }
          }}
        >
            <div className="modal-container">
                <h2>Confirm Delete</h2>
                <p>
                    Are you sure you want to delete <strong>{itemTitle}</strong>?
                </p>
                <div className="modal-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-delete" onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
